const ru = {
  about: 'О Проекте',
  companyManagement: 'Управление Компанией',
  articles: 'Статьи',
  contributorsTxt: 'участники',
  tools: 'Инструменты',
  library: 'Библиотека',
  longevity: 'Протокол Долголетия',
  aiAtlas: 'AI Атлас',
};

export default ru;
